import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { ErrorHandlerService } from '../../../shared/utils/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { EventStore } from '../../service/event.store';
import { ConfirmationModalConfig } from '../../../shared/confirmation-modal/confirmation-modal-config';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'pioneer-automatic-payment-toggle',
  templateUrl: './automatic-payment-toggle.component.html'
})
export class AutomaticPaymentToggleComponent implements OnInit {

  onyxEvent: OnyxEvent;

  @ViewChild(ConfirmationModalComponent)
  confirmationModal: ConfirmationModalComponent;

  confirmationModalConfig = new ConfirmationModalConfig();

  @Input()
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  constructor(
    private errorHandlerService: ErrorHandlerService,
    private translateService: TranslateService,
    private eventStore: EventStore
  ) {}

  ngOnInit(): void {

    if (!this.onyxEvent) {
      const logMessage = 'Input property onyxEvent is null in AutomaticPaymentToggleComponent';
      const labelKey = 'MESSAGES.ERROR.INPUT_PROPERTY_NULL';
      const params = {
        property: 'onyxEvent',
        className: 'AutomaticPaymentToggleComponent'
      };
      const flashMessage = this.translateService.instant(labelKey, params);
      this.errorHandlerService.throw(logMessage, flashMessage);
    }

  }

  confirmBeforeTogglingAutoPayment() {
    this.confirmationModalConfig.content = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_CONTENT');
    if (this.onyxEvent.autoPayment) {
      this.confirmationModalConfig.title = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_OFF_TITLE');
      this.confirmationModalConfig.confirm = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_OFF_CONFIRM');
    } else {
      this.confirmationModalConfig.title = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_ON_TITLE');
      this.confirmationModalConfig.confirm = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_ON_CONFIRM');
    }
    this.confirmationModal.open();
    return false;
  }

  confirmBeforeAutopaymentToggleHandler(value) {
    if (value) {
      this.toggleAutoPaymentSetting();
    }
  }

  toggleAutoPaymentSetting() {

    // https://facebook.github.io/immutable-js/docs/#/Map/merge
    const updatedModel = this.onyxEvent.merge({
      autoPayment: !this.onyxEvent.autoPayment,
    }) as OnyxEvent;

    this.eventStore.updateEvent(updatedModel).subscribe();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/automatic-payment-toggle/automatic-payment-toggle.component.ts